import React from "react";
import DailyEventSchedule2 from "../../components/EventSlotComponent2/Slot2";

function Index() {
  const eventData = [
    {
      startTime: "09:00",
      endTime: "10:00",
      title: "EVENT ACTIVITY 1",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo",
    },
    {
      startTime: "10:00",
      endTime: "11:00",
      title: "EVENT ACTIVITY 2",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo",
    },
    {
      startTime: "11:00",
      endTime: "12:00",
      title: "EVENT ACTIVITY 3",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo",
    },
    {
      startTime: "12:00",
      endTime: "13:00",
      title: "EVENT ACTIVITY 4",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisi ut aliquip ex ea commodo",
    },

    {
      startTime: "13:00",
      endTime: "14:00",
      title: "EVENT ACTIVITY 5",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam oh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation suscipit lobortis nisi ut aliquip ex ea commodo",
    },

    {
      startTime: "14:00",
      endTime: "15:00",
      title: "EVENT ACTIVITY 6",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo",
    },
    {
      startTime: "14:00",
      endTime: "15:00",
      title: "EVENT ACTIVITY 7",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo",
    },
    {
      startTime: "14:00",
      endTime: "15:00",
      title: "EVENT ACTIVITY 8",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo",
    },
  ];

  return <DailyEventSchedule2 data={eventData} />;
}

export default Index;